export default __webpack_public_path__ + "static/media/USDC.557426c8.png";